import { createTheme } from "@material-ui/core";

const palette = {
  primary: "#021496",
  secondary: "#8430c8",
};

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: palette.primary,
    },
    secondary: {
      main: palette.primary,
    },
    type: "light",
  },
  overrides: {
    MuiSnackbar: {
      anchorOriginBottomCenter: {
        bottom: "3rem !important",
      },
    },
  },
});

export const alternativeTheme = createTheme({
  palette: {
    primary: {
      main: palette.primary,
    },
    secondary: {
      main: palette.primary,
    },
    type: "dark",
  },
});
